import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FilesCombobox from "Components/Files/FilesCombobox";
import InvoicesCombobox from "Components/Invoice/InvoicesCombobox";
import PriceField from "Components/UI/Form/PriceField";

export default function EndcustomerPaidFormGeneral({
  formData,
  files,
  invoices,
  handleInputChange,
}) {
  return (
    <>
      <Grid container spacing={2} sx={{ marginTop: "5px" }}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            disabled
            name="Id"
            onChange={(e) =>
              handleInputChange("EndCustomerPayedInvoiceId", e.target.value)
            }
            label="Id"
            value={formData.Id}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="number"
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <InvoicesCombobox
            label="Faktura ID"
            selectedInvoiceID={formData.InvoiceId ? formData.InvoiceId : null}
            onChange={(newVal) => handleInputChange("InvoiceId", newVal)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <PriceField
            name="Amount"
            onChange={(newVal) => handleInputChange("Amount", newVal)}
            label="Belopp"
            value={formData.Amount}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="number"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="EndCustomerName"
            onChange={(e) =>
              handleInputChange("EndCustomerName", e.target.value)
            }
            label="Namn"
            value={formData.EndCustomerName}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          {/* <TextField
        name="file"
        onChange={(e) => handleInputChange("File", e.target.value)}
        label="Fil"
        value={formData.File}
        size="small"
        color="primary"
        fullWidth
        margin="dense"
        type="string"
      /> */}
          <FilesCombobox
            label="Fil"
            files={files}
            selectedFileID={formData.FileId}
            onChange={(newVal) => handleInputChange("FileId", newVal)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="OCR"
            onChange={(e) => handleInputChange("OCR", e.target.value)}
            label="OCR"
            value={formData.OCR}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="AccountRefId"
            onChange={(e) => handleInputChange("AccountRefId", e.target.value)}
            label="Slutkontskonto Ref"
            value={formData.AccountRefId}
            size="small"
            color="primary"
            fullWidth
            type="number"
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="PaymentDate"
            onChange={(e) => handleInputChange("PaymentDate", e.target.value)}
            label="Betalningsdatum"
            value={formData.PaymentDate}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
      </Grid>
    </>
  );
}
